import React from 'react';
import { getFormattedPoints } from '@components-member/Pages/LoyaltyProgram/utils';

interface ILoyaltyProgramHeaderPointsItemProps {
  loyaltyProgramName: string;
  loyaltyProgramPoints: number;
  pointsClassName: string;
  nameClassName: string;
  wrapperClassName: string;
  onClick?: () => void;
}

export const LoyaltyProgramHeaderPointsItem = ({
  loyaltyProgramName,
  loyaltyProgramPoints,
  pointsClassName,
  nameClassName,
  wrapperClassName,
  onClick,
}: ILoyaltyProgramHeaderPointsItemProps) => {
  return (
    <div onClick={onClick} className={wrapperClassName}>
      <span className={nameClassName}>{loyaltyProgramName}</span>
      <span className={pointsClassName}>{getFormattedPoints(loyaltyProgramPoints)}</span>
    </div>
  );
};
